import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import { Mutation, PspApplePaySessionInput } from "src/types/graphql.d";

export interface PspApplePaySessionData {
  pspApplePaySession: Mutation["pspApplePaySession"];
}

interface PspApplePaySessionVars {
  data: PspApplePaySessionInput;
}

interface PspApplePaySessionHook {
  data?: PspApplePaySessionData | null;
  loading: boolean;
  error?: ApolloError;
  pspApplePaySession: (dataVariable: PspApplePaySessionInput) => void;
}

const PSP_APPLE_PAY_SESSION = gql`
  mutation pspApplePaySession($data: PspApplePaySessionInput!) {
    pspApplePaySession(data: $data) {
      payment_id
      payment_session
    }
  }
`;

const usePspApplePaySession = ({
  refetchQueries = [],
  onCompleted,
}: {
  refetchQueries?: string[];
  onCompleted?: (pspApplePaySessionData: PspApplePaySessionData) => void;
} = {}): PspApplePaySessionHook => {
  const [pspApplePaySessionMutation, { data, loading, error }] = useMutation<
    PspApplePaySessionData,
    PspApplePaySessionVars
  >(PSP_APPLE_PAY_SESSION, {
    refetchQueries,
    onCompleted,
  });

  const pspApplePaySession = useCallback(
    (dataVariable: PspApplePaySessionInput) =>
      pspApplePaySessionMutation({
        variables: {
          data: dataVariable,
        },
      }),
    [pspApplePaySessionMutation]
  );

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return { pspApplePaySession, data, loading, error };
};

export { usePspApplePaySession };
